import React from "react";
import { Translate } from "react-redux-i18n";
import {
  FaPhone,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa";

import "./styles/ContactMe.css";
import Footer from "../components/Footer";
import logo from "../assets/logo_celeste.png";

function ContactItem({ icon: Icon, children }) {
  return (
    <div className="contact-item">
      <span className="contact-item__icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="contact-item__body">{children}</div>
    </div>
  );
}

class ContactMe extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="contact-page">
          <div className="contact-card">
            <header className="contact-card__header">
              <img
                src={logo}
                alt="Godiway"
                className="contact-card__logo"
              />
              <h1 className="contact-card__title">
                <Translate value="footer_contacts" />
              </h1>
              <p className="contact-card__subtitle">
                <Translate value="contact_me_subtitle" />
              </p>
            </header>

            <div className="contact-card__body">
              <ContactItem icon={FaPhone}>
                <p>
                  <Translate value="contact1" />
                </p>
                <p>
                  <Translate value="contact2" />
                </p>
              </ContactItem>

              <ContactItem icon={FaEnvelope}>
                <p>
                  <Translate value="contact3" />{" "}
                  <a
                    className="contact-link"
                    href="mailto:team@godiway.com"
                  >
                    team@godiway.com
                  </a>
                </p>
              </ContactItem>

              <ContactItem icon={FaFacebook}>
                <p className="contact-item__label">
                  <Translate value="contact4" />
                </p>
                <div className="contact-social">
                  <a
                    className="contact-social__link"
                    href="https://www.facebook.com/GodiWay-602264786813460"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook />
                    Facebook GodiWay
                  </a>
                  <a
                    className="contact-social__link"
                    href="https://twitter.com/GodiWay"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter />
                    Twitter GodiWay
                  </a>
                </div>
              </ContactItem>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default ContactMe;
